export default "__VITE_ASSET__BIdnkaBe__"